module.exports = __webpack_public_path__ + "static/media/template5.a4825e40.png";